import React, { useEffect, Fragment, useState } from 'react';
import Breadcrumb from '../../common/breadcrumb';
import FeatherComponent from '../../common/featherComponent';
import { Navigation, Box, MessageSquare, Users, HelpCircle, Mic, Zap } from 'react-feather';
import CountUp from 'react-countup';
import CandidateStats from "../../../components/dashboard/stats";
import request, { NodeURL, socket, socket_notify } from "../../../api/api"
import moment from "moment";
import jwt_decode from "jwt-decode";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { Modal, ModalBody, Button, ModalFooter, Col, Row } from "reactstrap";
import Select from "react-select";
import { toast } from "react-toastify";
import dashclient from "../../../images/candidate/dash-client.svg";
import blueeye from "../../../images/candidate/blue-eye.svg";
import notificationIcon from "../../../images/candidate/rs-envelope.svg";
import InterviewDashboard from "./interview/interview_dashboard";
import "./dashboard.scss";

const Default = (props) => {
    const [int, setInt] = useState(false);
    const [status, setStatus] = useState(0);
    const [notify, setNotify] = useState([]);
    const [isLoader, setIsLoader] = useState(false);
    const [OpenModal, setOpenModal] = useState(false);
    const [schedule, setSchedule] = useState({});
    const [alt_da, setAlt_Da] = useState([]);
    const [slct_alt_da, setSlct_Alt_Da] = useState([]);
    const [selected_alt, setSelectedAlt] = useState([]);
    const [set_y_n, setSet_y_s] = useState('');
    const [prefered_date, setPrefered_date] = useState('');
    const [alternate_date, setAlternate_date] = useState('');
    const [prefered_time, setPrefered_Time] = useState('');
    const [company_name, setCompany_Name] = useState('');
    const [first, setFirst] = useState(localStorage.getItem('first_time') || false);
    const [UserToken, setuserToken] = useState('');

    const get_profile = () => {
        request({
            url: "/employee/profile",
            method: "POST",
        }).then((res) => {
            if (res && +res.status === 1) {
                if (res && res.response.result && res.response.result && res.response.result.schedule && res.response.result.schedule.interview_time && res.response.result.schedule.interview_time.length > 0) {
                    setSchedule({ ...res.response.result.schedule });
                    setAlt_Da([...res.response.result.alternate_dates]);
                    if (res.response.result.alternate_dates && res.response.result.alternate_dates.length > 0) {
                        let lab_val = res.response.result.alternate_dates.filter((item) => {
                            if (item && item.alternate_date && item.alternate_date.length > 0) {
                                return item;
                            }
                        }).map((item) => {
                            return {
                                label: `${moment(item.alternate_date).format('DD-MM-YYYY')} ${item.alternate_time}`,
                                value: item._id,
                            }
                        });
                        setSlct_Alt_Da(lab_val);
                    }
                    if (res.response.result.agencydata && res.response.result.agencydata.length > 0) {
                        setCompany_Name(res.response.result.agencydata[0].company_name);
                    }
                }
            }
        }).catch((err) => {
            console.log(`err in const get_profile ${err}`)
        });
    }

    const get_application_status = () => {
        request({
            url: '/employee/get/application/status',
            method: 'POST',
            data: {}
        }).then(res => {
            if (res && +res.status === 1) {
                setStatus(Number(res.response.application_status));
            }
        }).catch(err => {
            console.log("err", err)
        })
    };

    const get_recent_notification = () => {
        request({
            url: '/employee/get/recent/notify',
            method: 'POST',
            data: {}
        }).then(res => {
            if (res && +res.status === 1) {
                setNotify(res.response);
            }
        }).catch(err => {
            console.log("err", err)
        })
    }

    let setyesno = (event, value) => {
        event.preventDefault();
        setSet_y_s(value)
        if (value === 'yes') {
            setOpenModal(true);
            setPrefered_date(''); setSelectedAlt([]); setAlternate_date('');
        }
    };

    let check_save = (event) => {
        event.preventDefault();
        if (!alternate_date && alternate_date.length === 0 && (prefered_date.length === 0 || prefered_time.length === 0)) {
            return toast.info('Please select atleast Prefered Date, Time or Alternate Date');
        } else {
            setOpenModal(true);
        }
    };

    let save = (event) => {
        event.preventDefault();
        let selected = '', selected_time = '';
        alt_da.map((item) => {
            if (item && String(item._id) === String(alternate_date)) {
                selected = item.alternate_date;
                selected_time = item.alternate_time;
            }
        });
        request({
            url: '/employee/interview/confirm',
            method: 'POST',
            data: { prefered_date, prefered_time, schedule, selected_time, alternate_date, selected_alt, selected, type: set_y_n }
        }).then((res) => {
            if (res && +res.status === 1) {
                toast.success(res.response);
                get_application_status();
                get_recent_notification();
                get_profile();
                setOpenModal(false);
                setSet_y_s('')
            } else {
                toast.error(res.response);
                setOpenModal(false);
            }
        }).catch((err) => {
            setOpenModal(false);
            console.log(`err let save ${err}`)
        });
    };

    const redirect_to = (evt, item) => {
        evt.preventDefault();
        evt.stopPropagation();
        if (item && item.readingStatus !== 1) {
            mark_read(item._id);
        }
        return props.history.push('/profile/viewprofile')
    };


    const mark_read = (id) => {
        request({
            url: "/employee/notification/markasread",
            method: "POST",
            data: { _id: id }
        }).then(response => {
            if (response && +response.status === 1) {
                get_recent_notification();
            }
            // setTimeout(() => {
            //   get_notify();
            // }, 1500);
        }).catch(error => {
            return toast.error(error);
        });
    };

    useEffect(() => {
        let Gettoken = localStorage.getItem("APUSEC");
        if (Gettoken) {
            let decodedtoken = jwt_decode(Gettoken);
            if (String(localStorage.getItem('first_time')) === String(first) && decodedtoken && decodedtoken.user_id && String(decodedtoken.user_id) === String(localStorage.getItem('loginWithFirstTime'))) {
                setFirst(true);
            } else {
                setFirst(false);
            }
        }
    }, []);

    useEffect(() => {
        get_application_status();
        get_recent_notification();
        get_profile();
        const interval1 = setInterval(() => {
            setInt(false);
        }, 1500000);
        const interval = setInterval(() => {
            setInt(true);
        }, 1800000);
        socket.on('notifications_application_form_submnit', (data) => {
            const tokenAgency = localStorage.getItem("APUSEC");
            if (tokenAgency) {
                const token = jwt_decode(tokenAgency);
                if (token && token.user_id && data && data._id) {
                    if (String(token.user_id) === String(data._id)) {
                        // get_application_status();
                        // get_recent_notification();
                    }
                }
            }
        });

        socket.on('notifications_application_form_status', (data) => {
            const tokenAgency = localStorage.getItem("APUSEC");
            if (tokenAgency) {
                const token = jwt_decode(tokenAgency);
                if (token && token.user_id && data && data._id) {
                    if (String(token.user_id) === String(data._id)) {
                        get_application_status();
                        get_recent_notification();
                    }
                }
            }
        });

        socket_notify.on('web notification', (data) => {
            const tokenAgency = localStorage.getItem("APUSEC");
            if (tokenAgency) {
                const token = jwt_decode(tokenAgency);
                if (token && token.user_id && data && data.username && data.username.length > 0) {
                    if (String(token.user_id) === String(data.username)) {
                        // get_application_status();
                        // get_recent_notification();
                    }
                }
            }
        });

        socket_notify.on('web_notification', (data) => {
            const tokenAgency = localStorage.getItem("APUSEC");
            if (tokenAgency) {
                const token = jwt_decode(tokenAgency);
                if (token && token.user_id && data && data.username && data.username.length > 0) {
                    if (String(token.user_id) === String(data.username)) {
                        // get_application_status();
                        // get_recent_notification();
                    }
                }
            }
        });

        socket.on('notifications_todo', (data) => {
            const tokenAgency = localStorage.getItem("APUSEC");
            if (tokenAgency) {
                const token = jwt_decode(tokenAgency);
                if (token && token.user_id && data && data._id && data._id.length > 0) {
                    if (String(token.user_id) === String(data._id)) {
                        // get_application_status();
                        // get_recent_notification();
                    }
                }
            }
        });

        socket.on('recruitment_notify', (data) => {
            const tokenAgency = localStorage.getItem("APUSEC");
            if (tokenAgency) {
                const token = jwt_decode(tokenAgency);
                if (token && token.user_id && data && data._id && data._id.length > 0) {
                    if (String(token.user_id) === String(data._id)) {
                        // get_application_status();
                        // get_recent_notification();
                    }
                }
            }
        });

        socket.on('notifications', (data) => {
            const tokenAgency = localStorage.getItem("APUSEC");
            if (tokenAgency) {
                const token = jwt_decode(tokenAgency);
                if (token && token.user_id && data && data._id && data._id.length > 0) {
                    if (String(token.user_id) === String(data._id)) {
                        // get_application_status();
                        // get_recent_notification();
                    }
                }
            }
        });

        socket.on('candidate_notify', (data) => {
            const tokenAgency = localStorage.getItem("APUSEC");
            if (tokenAgency) {
                const token = jwt_decode(tokenAgency);
                if (token && token.user_id && data && data._id) {
                    if (String(token.user_id) === String(data._id)) {
                        // get_application_status();
                        // get_recent_notification();
                    }
                }
            }
        });
        return () => {
            return clearInterval(interval), clearInterval(interval1);
        }
    }, []);


    let continue_form = () => {
        return props.history.push('/notification/list')
    };

    return (
        <Fragment>
            {int ? <CandidateStats /> : null}
            {String(first) === String(true) ? null : <CandidateStats />}
            <Breadcrumb parent="Dashboard" title="Dashboard" />
            <div className="container-fluid">
                <div className="row">
                    
                    <div className="dashboard-cates">

                        {/* <div className="col-sm-6 col-xl-3 col-lg-6">
                            <div className="card o-hidden">
                                <div className="bg-dash1 b-r-4 card-body">
                                    <div className="media static-top-widget">
                                        <h6>Earnings</h6>
                                        <h4><CountUp className="counter" end={0} /></h4>
                                        <div className="media-body">
                                            <div className="icon-bg">
                                                <i className="fa fa-user-plus" aria-hidden="true"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-xl-3 col-lg-6">
                            <div className="card o-hidden">
                                <div className="bg-dash2 b-r-4 card-body">
                                    <div className="media static-top-widget">
                                        <div className="align-self-center text-center">
                                            <h6>Products</h6>
                                            <h4><CountUp className="counter" end={0} /></h4>
                                        </div>
                                        <div className="media-body">
                                            <div className="icon-bg">
                                                <i className="fa fa-user-plus" aria-hidden="true"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-xl-3 col-lg-6">
                            <div className="card o-hidden">
                                <div className="bg-dash3 b-r-4 card-body">
                                    <div className="media static-top-widget">
                                        <h6>Messages</h6>
                                        <h4><CountUp className="counter" end={0} /></h4>
                                        <div className="media-body">
                                            <div className="icon-bg">
                                                <i className="fa fa-user-plus" aria-hidden="true"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-xl-3 col-lg-6">
                            <div className="card o-hidden">
                                <div className="bg-dash4 b-r-4 card-body">
                                    <div className="media static-top-widget">
                                        <h6>New User</h6>
                                        <h4><CountUp className="counter" end={0} /></h4>
                                        <div className="media-body">
                                            <div className="icon-bg">
                                                <i className="fa fa-user-plus" aria-hidden="true"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                     */}
                    </div>

                    <div className="notification-dashboard">
                        <div className="col-md-6">
                            <div className="status-dash">
                                <div className="dash-header notify-clr">
                                    <h5><img src={notificationIcon} alt="admin" /> <span>Recent Notification</span>
                                        <span className="aggg-view" onClick={(e) => { continue_form() }}>
                                            <img src={blueeye} alt="view" />
                                            View All
                                        </span>
                                    </h5>
                                </div>
                                <div className="card-body recent-notification">
                                    {
                                        notify && notify.length > 0 && Array.isArray(notify) ?
                                            (
                                                notify.map((item, index) => {
                                                    return (
                                                        <div className="media" key={index} onClick={(e) => redirect_to(e, item)} style={{ cursor: 'pointer' }} >
                                                            <h6>{moment(new Date(item.createdAt)).format('DD-MM-YYYY HH:mm')}</h6>
                                                            <div className="media-body">
                                                                <span className="noti-lines">{item.message}</span>
                                                                {item.raw_data && item.raw_data.notes && item.raw_data.notes !== '' ? <span className="mb-0">{item.raw_data.notes}</span> : null}
                                                                {/* <p className="f-12">By Kan</p> */}
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            )
                                            :
                                            <div className="no-data">
                                                <p>{!isLoader && <span>No recent notification</span>}</p>
                                            </div>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="status-dash">
                                <div className="dash-header notify-clr1">
                                    <h5><img src={dashclient} alt="admin" /><span>Interview Schedule</span>
                                        <span className="aggg-view" onClick={()=> props.history.push('/interview/list')}> 
                                            <img src={blueeye} alt="view" />
                                            View All
                                        </span>
                                    </h5>
                                </div>

                                <div className="dashboard-table">
                                    <div className="upcoming-event">
                                        <InterviewDashboard/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="status-dash">
                                <div className="dash-header notify-clr1">
                                    <h5><img src={dashclient} alt="admin" /><span>Application Form Status</span>
                                        <span className="aggg-view">
                                            <img src={blueeye} alt="view" />
                                            View All
                                        </span>
                                    </h5>
                                </div>

                                <div className="card-body app-stus">
                                    <div className="timeline-small">
                                        <div className="media">
                                            {
                                                (Number(status) === 3 || Number(status) === 4 || Number(status) === 1) ? (
                                                    <>
                                                        <div className="timeline-round m-r-30 timeline-line-1 bg-primary">
                                                            <FeatherComponent dataFeather="shopping-bag" />
                                                        </div>
                                                        <div className="media-body">
                                                            <h6>Application Form has been submitted and under review <span className="pull-right f-14"></span></h6>
                                                        </div>
                                                    </>
                                                ) : (
                                                    <>
                                                        <div className="timeline-round m-r-30 timeline-line-1 bg-primary">
                                                            <FeatherComponent dataFeather="alert-octagon" />
                                                        </div>
                                                        <div className="media-body">
                                                            <h6>You can check your application status here once you have applied for it. <span className="pull-right f-14"></span></h6>
                                                        </div>
                                                    </>
                                                )
                                            }
                                        </div>
                                        <div className="media">
                                            {
                                                (Number(status) === 3 || Number(status) === 4 || Number(status) === 2) ? (
                                                    <>
                                                        <div className="timeline-round m-r-30 timeline-line-1 bg-warning">
                                                            <FeatherComponent dataFeather="shopping-bag" />
                                                        </div>
                                                        <div className="media-body">
                                                            <h6>You have been accepted for an Interview Process <span className="pull-right f-14"></span></h6>
                                                        </div>
                                                    </>
                                                ) : null
                                            }
                                        </div>
                                        <div className="media">
                                            {
                                                Number(status) === 3 ? (
                                                    <>
                                                        <div className="timeline-round m-r-30 timeline-line-1 bg-success">
                                                            <FeatherComponent dataFeather="shopping-bag" />
                                                        </div>
                                                        <div className="media-body">
                                                            <h6>You have been selected <span className="pull-right f-14"></span></h6>
                                                        </div>
                                                    </>
                                                ) : null
                                            }
                                        </div>
                                        <div className="media">
                                            {
                                                Number(status) === 4 ? (
                                                    <>
                                                        <div className="timeline-round m-r-30 timeline-line-1 bg-danger">
                                                            <FeatherComponent dataFeather="shopping-bag" />
                                                        </div>
                                                        <div className="media-body">
                                                            <h6>You have been rejected <span className="pull-right f-14"></span></h6>
                                                        </div>
                                                    </>
                                                ) : null
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </Fragment >
    );
};

export default Default;